import { regex } from 'vee-validate/dist/rules';
import { ValidatorUtils } from './utils';

export const atLeastOneLetterValidator = {
    ...regex,
    message(field: string) {
        return `'${ValidatorUtils.prettifyName(field)}' requires at least one letter.`;
    },
};
